import ApplicationsRequests from './applications';
import AssetsRequests from './assets';
import AuthRequests from './auth';
import AuthFormsRequests from './authForms';
import FormsRequests from './forms';
import MFARequests from './mfa';
import UsersRequests from './users';

const AccountClientRequests = {
	Assets: AssetsRequests,
	Auth: AuthRequests,
	Users: UsersRequests,
	Applications: ApplicationsRequests,
	Forms: FormsRequests,
	MFA: MFARequests,
	AuthForms: AuthFormsRequests,
};

export default AccountClientRequests;
